module.exports = __webpack_public_path__ + "static/media/hbs.dcdc5359.svg";